exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-sub-lk {\n  font-size: 13px;\n  font-weight: 500;\n  color: #777;\n  margin-top: 30px;\n  margin-bottom: 0px;\n  text-align: left;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/auth/link-account.css
// module id = ../../../../../src/app/pages/admin/auth/link-account.css
// module chunks = 3